module.exports = __webpack_public_path__ + "static/media/licensing.ef4f9305.svg";